exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".textcalc {\n  font-size: 2em;\n}\n.inputCalculator {\n  margin-bottom: 4%;\n}\n\n.inputcalc {\n  border-radius: 3px;\n  margin-top: 3%;\n  margin-left: 3%;\n  padding: 1%;\n  font-size: 2em;\n  width: 80%;\n  border: 1px solid #c8c8c8;\n  -webkit-box-shadow: 2px 2px 2px #f2f2f2;\n  outline: 0;\n}\n.inputcalc-income {\n  width: 20%;\n}\n\n.right-calc {\n  float: right;\n  display: block;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader!./app/css/main_calculator.css
// module id = 245
// module chunks = 0